(function (win) {
  var toString = Object.prototype.toString
  var clickAttribute = 'ga-click', viewAttribute = 'ga-view'
  var CLICK_CONFIG_DATA = {
    // key为时间戳, 后期上后管自动生成
    '1621300134507': [ 
      'event',
      'SUNCHASERS CLUB::click',
      { 
        'event_category':'homepage',
        'event_label':'Memorial Day_btn::SHOP NOW',
  
      }
    ],
    '1621304741730': [
      'event',
      'SUNCHASERS CLUB::click',
      { 
        'event_category':'homepage',
        'event_label':'Memorial Day_btn::SHOP NOW'
      }
    ]
  }
  var VIEW_CONFIG_DATA = {
    // key为时间戳, 后期上后管自动生成

    '1621304741730': [
      'event',
      'SUNCHASERS CLUB::view',
      { 
        'event_category':'homepage',
        'event_label':'Memorial Day_btn::SHOP NOW'
      }
    ]
  }
  /**
   * @description 节流
   * @param {*} fn 
   * @param {*} wait 
   * @returns 
   */
  function throttle(fn,wait){
    var pre = Date.now();
    var context = this;
    return function(){
      var args = arguments;
      var now = Date.now();
      if( now - pre >= wait){
          fn.apply(context,args);
          pre = Date.now();
      }
    }
  }

  /**
   * @description 判断dom是否在可视区域内
   * @param {*} id 
   * @returns 
   */
  function isElementInViewport (id) {
    var el = document.querySelector(`[${viewAttribute}="${id}"]`)
   if (!el) {
     console.warn(`Warning: ${viewAttribute}为[${id}]的节点不存在`)
     return
   }
   var rect = el.getBoundingClientRect();
   return (
       rect.top >= 0 &&
       rect.left >= 0 &&
       rect.bottom <= (win.innerHeight || document.documentElement.clientHeight) &&
       rect.right <= (win.innerWidth || document.documentElement.clientWidth)
   );
 }
 function isObject (param) { 
   return toString.call(param) === '[object Object]'
 }

 function isArray (param) {
  return toString.call(param) === '[object Array]'
 }
  /**
   * @description 基类
   * @param { Array } configs 基础配置项 
   */
  function GAObserver (configs) {
    this.stacks = configs
  }
  /**
   * @description 订阅
   * @param {*} config 订阅参数
   */ 
  GAObserver.prototype.subscribe = function (config) {
    debugger
    if (config != undefined) {
      if (isObject(config)) {
        Object.assign(this.stacks, config)
      } else if (isArray(config)) {
        config.forEach(t => {
          Object.assign(this.stacks, t)
        })
      }
    }
  }
  
  /**
   * @description 取消订阅
   * @param {*} id 订阅号
   * @returns 
   */
  GAObserver.prototype.unSubscribe = function (id) {
    if (!id in this.stacks) {
      console.error(`Warning: ${viewAttribute}为[${id}]的组件，未注册可视区域埋点事件`)
      return
    }
    delete this.stacks[key]
  }
  
  /**
   * @description 点击事件埋点观察者
   * @param {'*'} configs 
   */
  function ClickGAObserver (configs) {
    GAObserver.call(this, configs)
  }

  ClickGAObserver.prototype = new GAObserver()

  ClickGAObserver.prototype.notify = function (e) {
    var id = e.target.getAttribute(clickAttribute) || -1
    var args = this.stacks[id]
    if (isArray(args)) {
      gtag.apply(win,args)
    }
  }

  /**
   * @description 收集当前页面需要可视区域处罚的埋点事件
   */
   ClickGAObserver.prototype.depend = function () {
    var context = this
    document.querySelectorAll(`[${clickAttribute}]`).forEach(elm => {
      // target指向当前点击的元素，所有只能绑定click事件
      elm.addEventListener('click', function () {
        var id = elm.getAttribute(clickAttribute)
        var args = context.stacks[id]
        if (isArray(args)) {
          gtag.apply(win,args)
        }
      })
    })
  }

  /**
   * @description 可视区域埋点观察者
   * @param {*} configs 
   */
  function ViewGAObserver (configs) {
    GAObserver.call(this, configs)
  }
  ViewGAObserver.prototype = new GAObserver()

  /**
   * @description 可视区域埋点通知订阅者
   */
  ViewGAObserver.prototype.notify = function () {
    for (var id in this.stacks) {
      // 判断是否在可视区域
      if (isElementInViewport(id)) {
        var args = this.stacks[id]
        if (isArray(args)) {
          gtag.apply(win,args)
        }
      }
    }
  }

  var clickGAInstance = new ClickGAObserver(CLICK_CONFIG_DATA)

  var viewGAInstance = new ViewGAObserver(VIEW_CONFIG_DATA)
  win.GA = {
    click: clickGAInstance || {},
    view: viewGAInstance || {}
  }
  // 防止子元素禁止冒泡，window点击事件绑定在捕获阶段触发
  // win.addEventListener('click', throttle.call(clickGAInstance,clickGAInstance.notify, 1000), true)
  win.addEventListener('load', function () { clickGAInstance.depend() })
  win.addEventListener("scroll",throttle.call(viewGAInstance,viewGAInstance.notify,100));

})(window || {})